import { Alert, ButtonBase, Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTranslation } from 'react-i18next';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { Flooding } from 'features/flooding/flooding.types';
import { makeStyles } from 'tss-react/mui';
import type { CSSObject } from 'tss-react';

type GeoEventEvacuationsButtonProps = {
  geoEvent: Wildfire | Flooding;
  handleTop: () => void;
};

const useStyles = makeStyles()((theme) => ({
  alert: {
    alignItems: 'center',
    paddingBottom: 12,
    paddingTop: 12,
    width: '100%',
    '& .MuiAlert-icon': {
      alignSelf: 'center',
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiAlert-message': {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      padding: 0,
    },
    '& .MuiAlert-action': {
      alignItems: 'center',
      alignSelf: 'center',
      marginRight: 0,
      paddingBottom: 0,
      paddingTop: 0,
    },
  } as CSSObject,
  btn: {
    borderRadius: 12,
    width: '100%',
  },
}));

export const GeoEventEvacuationsButton = (
  props: GeoEventEvacuationsButtonProps,
): JSX.Element | null => {
  const { geoEvent, handleTop } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const {
    data: {
      evacuationOrders,
      evacuationWarnings,
      evacuationAdvisories,
      evacuationShelterInPlace,
      evacuationNotes,
    },
  } = geoEvent;

  if (
    !evacuationOrders &&
    !evacuationWarnings &&
    !evacuationAdvisories &&
    !evacuationShelterInPlace &&
    !evacuationNotes
  ) {
    return null;
  }

  return (
    <Box sx={{ px: 2, pb: 1, pt: 0, bgcolor: 'background.paper' }}>
      <ButtonBase role="button" onClick={handleTop} className={classes.btn}>
        <Alert
          severity="error"
          className={classes.alert}
          icon={<ErrorIcon fontSize="small" />}
          action={
            <ExpandLessIcon fontSize="small" sx={{ color: 'text.primary' }} />
          }
        >
          <Typography
            variant="body1"
            sx={[
              (theme) => ({
                fontWeight: 500,
                color: theme.palette.common.black,
              }),
              (theme) =>
                theme.applyStyles('dark', {
                  color: theme.palette.grey[100],
                }),
            ]}
          >
            {t('geoEvent.evacBtnTitle')}
          </Typography>
        </Alert>
      </ButtonBase>
    </Box>
  );
};
